import { createGlobalStyle } from "styled-components";

const Typography = createGlobalStyle`

html {
    font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    color: var(--white);
}
h1,h2,h3,h4,h5,h6 {
    margin: 0;
  }
`;

export default Typography;
